import { Injectable } from '@angular/core';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';

@Injectable({
  providedIn: 'root'
})
export class LecteurStorageService {
  private readonly filenames = {
    deviceId: 'deviceIdSCE.txt',
    lecteurName: 'lecteurNameSCE.txt'
  };

  private async readFile(filename: string): Promise<string | null> {
    try {
      const result = await Filesystem.readFile({
        path: filename,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });
      return result.data as string;
    } catch (e) {
      return null;
    }
  }

  private async writeFile(filename: string, value: string): Promise<void> {
    await Filesystem.writeFile({
      path: filename,
      data: value,
      directory: Directory.Data,
      encoding: Encoding.UTF8,
    });
  }

  private async deleteFile(filename: string): Promise<void> {
    try {
      await Filesystem.deleteFile({
        path: filename,
        directory: Directory.Data
      });
    } catch (e) {
      console.warn(`Erreur non fatale lors de la suppression de ${filename}`);
    }
  }

  async getDeviceId(): Promise<string | null> {
    return this.readFile(this.filenames.deviceId);
  }

  async setDeviceId(value: string): Promise<void> {
    return this.writeFile(this.filenames.deviceId, value);
  }

  async removeDeviceId(): Promise<void> {
    return this.deleteFile(this.filenames.deviceId);
  }

  async getLecteurName(): Promise<string | null> {
    return this.readFile(this.filenames.lecteurName);
  }

  async setLecteurName(value: string): Promise<void> {
    return this.writeFile(this.filenames.lecteurName, value);
  }

  async removeLecteurName(): Promise<void> {
    return this.deleteFile(this.filenames.lecteurName);
  }
}
